import React, { useState, useContext, useRef } from 'react'
import { strCol, numCol } from '@integec/grid-tools/lib/cols'
import { utilityHeader, unitIdHeader } from 'core/HeaderColTypeProps'
import { getApiTargetInfo, UnitSelection } from 'core'
import { connect } from 'react-redux'
import { exportNYISOFile, processNYISOFileCreation } from 'api/pgads.js'
import {
  getUtilityNameMap,
  getUnitNameMap,
  //   getUtilityUnitsMap,
  //   getPermitActions,
  //   getEnvConfig,
  //   getClientInfo,
} from 'core/selectors'
// import ErrorModal from 'core/component/ErrorModal'
import { Button, Input, Select, InputNumber, message } from 'antd'
import {
  CriteriaRow,
  Title,
  Content,
  FullHeightSizer,
  Filler,
} from 'core/screen-util'
import Grid, { virtualizedGridRenderer } from '@integec/grid-tools'
import { rowHeaderRender, monthsMap } from 'core/utils'
import moment from 'moment'
import { ErrorContext, SpinContext, UnitSelectionContext } from 'context'

const fileCreationTask = apiTargetInfo =>
  processNYISOFileCreation(apiTargetInfo)

const headers = [
  utilityHeader,
  unitIdHeader,
  numCol({
    ident: 'year',
    display: 'Year',
    isFiltered: true,
    displayFormat: '0',
  }),
  numCol({
    ident: 'month',
    display: 'Month',
    isFiltered: true,
    displayFormat: '0',
  }),
  numCol({
    ident: 'errorCode',
    display: 'Error Code',
    isFiltered: true,
    displayFormat: '0',
  }),
  strCol({
    ident: 'error',
    display: 'Error',
    width: 500,
    ellipsis: true,
    isFiltered: true,
  }),
]
const title = 'NYISO File Creation'

const NYISOFileCreation = ({
  apiTargetInfo,
  //   CLIENT,
  utilityNameMap,
  unitNameMap,
}) => {
  const [startMonth, setStartMonth] = useState('1')
  const [endMonth, setEndMonth] = useState('12')
  const [year, setYear] = useState(moment().year())
  const { setError } = useContext(ErrorContext)
  const { setSpinning, spinning } = useContext(SpinContext)
  const { selectedUnits, setVisibleUnitSelection } = useContext(
    UnitSelectionContext
  )
  const [fuzzyFilter, setFuzzyFilter] = useState('')
  const GridRef = useRef()
  const [data, setData] = useState([])
  const [showCreateButton, setShowCreateButton] = useState(true)

  const headerWithFormatter = headers.map(header =>
    header.ident === 'utility'
      ? {
          ...header,
          dataFormatter: ({ value }) => utilityNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            utilityNameMap[rowData.utility] || rowData.utility,
        }
      : header.ident === 'unitId'
      ? {
          ...header,
          dataFormatter: ({ value }) =>
            value.substr(value.length - 3) === 'ALL'
              ? 'ALL-ALL Units'
              : unitNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            unitNameMap[rowData.unit] || rowData.unit,
        }
      : header
  )

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const withCriteria = () => ({
    year,
    startMonth,
    endMonth,
    unitId: selectedUnits.map(u => u.unitId),
  })

  const exportData = (blobData, type, fileName) => {
    const a = window.document.createElement('a')
    a.href = window.URL.createObjectURL(
      new Blob(blobData, { type: 'text/plain' }),
      { type }
    )
    a.download = fileName
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  const exportDataWithType = (data, type) => {
    if (type === 'ALL') exportData(data, 'text/plain', 'nerc-05-07.txt')
    else
      exportData(
        data,
        'text/plain',
        'nyiso-file.txt'
        // 'nerc-' + type + '.txt'
      )
  }

  const onCreateFile = _ => {
    if (selectedUnits.length === 0) {
      message.error('Please , Select Units')
      setVisibleUnitSelection(true)
      return
    }

    const cdata = withCriteria()
    setSpinning(true)

    const exportFile = _ =>
      exportNYISOFile(apiTargetInfo)(cdata).fork(setError, data => {
        setData([])
        setShowCreateButton(true)
        setSpinning(false)
        // if (fileFormat === 'ONE') exportDataWithType(data, 'ALL')
        // else {
        //   exportDataWithType(data, '05')
        //   exportDataWithType(data, '07')
        // }
        exportDataWithType(data, 'nyiso')
      })

    showCreateButton
      ? fileCreationTask(apiTargetInfo)(cdata).fork(setError, data => {
          setData(data)
          // setData95(data.CARD95)
          // setData97(data.CARD97)
          setShowCreateButton(false)
          setSpinning(false)
          if (data.length <= 0) {
            exportFile()
          }
        })
      : exportFile()
    // )(b => {
    //     setData([])
    //     setShowCreateButton(true)
    //     setSpinning(false)
    //   })
  }

  return (
    <div>
      <UnitSelection />
      {/* setData={() => onCriteriaChnage()}
       disabled={!showCreateButton}
       nercGroup={nercGroup}
       /> */}
      <CriteriaRow style={{}}>
        <Title
          style={{
            marginRight: '15px',
            marginBottom: '5px',
            marginLeft: '10px',
            minWidth: '150px',
          }}
        >
          {title}
        </Title>
        <div>
          <h3 style={{ display: 'inline', paddingLeft: '20px' }}>Year :</h3>
          <InputNumber
            value={year}
            onChange={value => setYear(value)}
            style={{ width: '100px', marginLeft: '5px' }}
          />
          <h3 style={{ display: 'inline', paddingLeft: '20px' }}>From :</h3>
          <Select
            style={{ width: '120px', marginLeft: '5px' }}
            value={startMonth}
            onChange={val => setStartMonth(val)}
          >
            {Object.keys(monthsMap).map(m => (
              <Select.Option key={m} value={m}>
                {monthsMap[m]}
              </Select.Option>
            ))}
          </Select>
          <h3 style={{ display: 'inline', paddingLeft: '20px' }}>To :</h3>
          <Select
            style={{ width: '120px', marginLeft: '5px' }}
            value={endMonth}
            onChange={val => setEndMonth(val)}
          >
            {Object.keys(monthsMap).map(m => (
              <Select.Option key={m} value={m}>
                {monthsMap[m]}
              </Select.Option>
            ))}
          </Select>
        </div>
        <Button
          type="primary"
          style={{ marginLeft: '10px' }}
          onClick={onCreateFile}
          disabled={!showCreateButton}
          icon="file-add"
        >
          Create File
        </Button>
        <Button
          type="primary"
          style={{ marginLeft: '5px' }}
          onClick={onCreateFile}
          disabled={showCreateButton}
          loading={spinning}
          icon="caret-right"
        >
          Continue
        </Button>
        <Button
          type="danger"
          style={{ marginLeft: '5px' }}
          onClick={_ => {
            setData([])
            setShowCreateButton(true)
          }}
          disabled={showCreateButton}
          loading={spinning}
          icon="stop"
        >
          Abort
        </Button>
        <Filler />
        <Input.Search
          placeholder="Filter"
          value={fuzzyFilter}
          style={{
            marginLeft: '10px',
            marginRight: '10px',
            flex: '0 0 200px',
          }}
          onChange={e => setFuzzyFilter(e.target.value)}
        />
      </CriteriaRow>
      <FullHeightSizer heightOffset={230}>
        {({ height, width }) => (
          <Content style={{ height: height - 20 }}>
            <Grid
              ref={GridRef}
              sortEnabled
              data={data}
              headers={headerWithFormatter}
              altBy={u => u.unit}
              altBgColor="#ebebeb"
              render={virtualizedGridRenderer({
                autoFixColByKey: true,
                rowHeaderRender,
                height: height - 60,
                width: width - 50,
                // cellRender: customizedCellRender,
              })}
              fuzzyFilter={fuzzyFilter}
              isEditable={false}
              initialSortOptions={headers}
            />
          </Content>
        )}
      </FullHeightSizer>
    </div>
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  //   actionPermits: getPermitActions(state),
  //   CLIENT: getClientInfo(state),
})

export default connect(mapStateToProps)(NYISOFileCreation)
